import { render, staticRenderFns } from "./role-view.vue?vue&type=template&id=b16f80fe&"
import script from "./role-view.vue?vue&type=script&lang=js&"
export * from "./role-view.vue?vue&type=script&lang=js&"
import style0 from "./role-view.vue?vue&type=style&index=0&id=b16f80fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports